import React, { FC } from 'react';
import { DateTime } from 'luxon';

import TicketCommentDto from 'types/api/TicketCommentDto';
import useUser from 'hooks/useUser';

import './Comment.scss';

export interface CommentProps {
  comment: TicketCommentDto;
}

const Comment: FC<CommentProps> = ({ comment }) => {
  const initials = comment.commenter.first_name[0] + comment.commenter.last_name[0];
  const user = useUser();

  return (
    <div className={`enkrateia-ticket-comment ${user.id === comment.commenter.id ? 'my-comment' : ''}`}>
      <div className="avatar">{initials}</div>
      <div className="content">
        <h3>
          {comment.commenter.first_name} {comment.commenter.last_name}
        </h3>
        <p className="timestamp">{DateTime.fromISO(comment.comment_time).toFormat('d-MMM-yyyy hh:mma')}</p>
        <p className="comment">{comment.ticket_comment}</p>
      </div>
    </div>
  );
};

export default Comment;
